import {
  PESQUISAS_PRINCIPAL,
  PESQUISAS_INDICADORES,
  PESQUISAS_ATIVOS,
  PESQUISAS_PESSOAS,
  PESQUISAS_GESTORES,
  PESQUISAS_ADMINISTRADORES,
  PESQUISAS_CARTEIRAS,
  PESQUISAS_LOGOUT
} from '../../const/actionsType';

export function acPesquisasGlobalChanged(pData) {
  return {
    type: PESQUISAS_PRINCIPAL,
    payload: pData
  };
}
export function acPesquisasIndicadoresChanged(pData) {
  return {
    type: PESQUISAS_INDICADORES,
    payload: pData
  };
}

export function acPesquisasAtivosChanged(pData) {
  return {
    type: PESQUISAS_ATIVOS,
    payload: pData
  };
}

export function acPesquisasPessoasChanged(pData) {
  return {
    type: PESQUISAS_PESSOAS,
    payload: pData
  };
}

export function acPesquisasGestoresChanged(pData) {
  return {
    type: PESQUISAS_GESTORES,
    payload: pData
  };
}

export function acPesquisasAdministradoresChanged(pData) {
  return {
    type: PESQUISAS_ADMINISTRADORES,
    payload: pData
  };
}

export function acPesquisasCarteirasChanged(pData) {
  return {
    type: PESQUISAS_CARTEIRAS,
    payload: pData
  };
}

export function acPesquisasLogout() {
  return {
    type: PESQUISAS_LOGOUT
  };
}
